import React from "react";
import { 
  ShieldCheck, 
  UserCircle, 
  Database, 
  Scale, 
  AlertTriangle,
  FileText,
  Clock,
  ArrowRight
} from "lucide-react";
import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="tos-page-shell">
      <Navigation />
      
      {/* Sovereign Visual Overlays */}
      <div className="tos-tactical-grid"></div>
      <div className="tos-scanline-overlay"></div>
      <div className="tos-laser-scanner"></div>
      <div className="tos-radial-depth"></div>

      <main className="tos-content-hub">
        
        {/* Header Node */}
        <header className="tos-hero-sector">
          <div className="tos-badge-container">
            <div className="tos-hud-badge">
              <FileText size={14} className="tos-icon-blue tos-pulse" />
              <span>LEGAL_CENTER_V3.1</span>
            </div>
          </div>
          <h1 className="tos-hero-title">SERVICE <span className="tos-highlight">CONDITIONS</span></h1>
          <div className="tos-hero-subtitle">
            <span>VERSION: 2026.04.B</span>
            <span className="tos-sep">|</span>
            <span>LAST_AUDIT: MAR_31_2026</span>
          </div>
        </header>

        {/* Global Principles Grid */}
        <section className="tos-summary-grid">
          <div className="tos-summary-card tos-glass">
            <div className="tos-summary-icon-box">
              <UserCircle size={24} />
            </div>
            <h3>USER_OVERSIGHT</h3>
            <p>Authorized users maintain 100% responsibility for clinical account security and biometric data accuracy.</p>
            <div className="tos-card-brackets"></div>
          </div>

          <div className="tos-summary-card tos-glass">
            <div className="tos-summary-icon-box green">
              <Database size={24} />
            </div>
            <h3>DATA_CUSTODY</h3>
            <p>You retain sovereign ownership of all health assets. Medico acts solely as a secure clinical processor.</p>
            <div className="tos-card-brackets"></div>
          </div>

          <div className="tos-summary-card tos-glass">
            <div className="tos-summary-icon-box orange">
              <Scale size={24} />
            </div>
            <h3>SCOPE_PROTOCOL</h3>
            <p>Monitoring telemetry is for informational oversight and does not constitute a legal medical diagnosis.</p>
            <div className="tos-card-brackets"></div>
          </div>
        </section>

        {/* Detailed Terms Stack */}
        <div className="tos-protocol-stack">
          
          <section className="tos-protocol-section tos-glass">
            <div className="tos-section-header">
              <ShieldCheck size={28} className="tos-icon-blue" />
              <h2>01. PROTOCOL_ACCEPTANCE</h2>
            </div>
            <div className="tos-section-body">
              <p>By initializing a session on the Medico platform, you execute a binding agreement to abide by these terms. Unauthorized use of clinical identity assets is strictly prohibited under sovereign data laws.</p>
            </div>
          </section>

          <section className="tos-protocol-section tos-glass">
            <div className="tos-section-header">
              <Database size={28} className="tos-icon-green" />
              <h2>02. IOT_NODE_USAGE</h2>
            </div>
            <div className="tos-section-body">
              <ul className="tos-list">
                <li>
                  <strong>SENSOR_COMPATIBILITY:</strong> All connected IoT nodes must maintain verified clinical certification.
                </li>
                <li>
                  <strong>TELEMETRY_INTEGRITY:</strong> Intentional spoofing or manipulation of vital sign data is a breach of security protocols.
                </li>
              </ul>
            </div>
          </section>

          <section className="tos-protocol-section tos-glass">
            <div className="tos-section-header">
              <AlertTriangle size={28} className="tos-icon-orange" />
              <h2>03. CLINICAL_DISCLAIMER</h2>
            </div>
            <div className="tos-section-body">
              <div className="tos-disclaimer-node tos-glass-inner">
                <p><strong>SYSTEM_NOTICE:</strong> Medico.in is an IOT monitoring engine, NOT a certified medical diagnostic device. Telemetry data is informational. Always verify vitals with a human medical professional for diagnostic accuracy.</p>
              </div>
            </div>
          </section>

          <section className="tos-protocol-section tos-glass">
            <div className="tos-section-header">
              <Clock size={28} className="tos-icon-purple" />
              <h2>04. SESSION_TERMINATION</h2>
            </div>
            <div className="tos-section-body">
              <p>Medico reserves the right to de-authorize any clinical node or user identity found in violation of security integrity protocols or engaging in fraudulent telemetry transmissions.</p>
            </div>
          </section>

          <section className="tos-footer-sector center">
            <p>Questions regarding legal protocols? <a href="/contact" className="tos-contact-anchor">CONTACT_LEGAL_NODE</a></p>
            <button className="tos-protocol-btn">
              AUTHORIZE_PROTOCOL_AGREEMENT <ArrowRight size={18} />
            </button>
          </section>

        </div>
      </main>
      <FooterSection />
    </div>
  );
};

export default TermsAndConditions;
